
import {ElLoading} from "element-plus";

const columnList: Array<column> = [
    {
        prop: "order_sn",
        label: "工单号",
        width: 82,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 82,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 82,
    },
    {
        prop: "car_name",
        label: "车型",
        width: 82,
    },
    {
        prop: "name",
        label: "项目",
        width: 82,
    },
    {
        prop: "construct_name",
        label: "施工人",
        width: 82,
    },
    {
        prop: "branch_name",
        label: "部门",
        width: 82,
    },

    {
        prop: "offer_price",
        label: "报价金额",
        width: 82,
    },
    {
        prop: "output_value",
        label: "销售金额",
        width: 82,
    },
    {
        prop: "build_num",
        label: "施工人数",
        width: 82,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 82,
    },
    {
        prop: "build_yj",
        label: "业绩",
        width: 82,
    },
    {
        prop: "build_bonus_price",
        label: "提成",
        width: 82,
    },
];
import { Request } from "@/api/request";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {getPurchaseTable, getSupplierList, projectConstructionExport, purchaseCopeExport} from "@/api/http";
import { column } from "@/assets/types/common";
import { accAdd } from "@/api/api";
import {getFirstNowLastDay} from "@/api/date";

export default defineComponent({
    name: "ProjectConstruction",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["项目施工明细"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            headClass = inject("headClass"),
            screenParameter = reactive({
                time: [getFirstNowLastDay()[0],getFirstNowLastDay()[1]],
                page: 1,
                pagesize: 10,
                search: "",
                start_time: null,
                end_time: null,
                branch_id: null,
                project_id: null,
                constructor_id: null,
                status: 2,
            } as any),
            dialog_show = ref(false),
            form_isload = ref(false),
            form = ref({
                name: "",
                phone: "",
                nickname: "",
                position_id: "",
                branch_id: "",
                role_id: "",
                gender: "",
                qq: "",
                wechat: "",
                email: "",
                identity_number: "",
                address: "",
                entry_time: "",
            } as any),
            selectList = ref({
                branch: [],
                project: [],
                staff:[]
            } as any),
            formRef = ref(null),
            formRules = {
                name: [{ required: true, message: "必填", trigger: "blur" }],
                role_id: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
                gender: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
                nickname: [
                    { required: true, message: "必填", trigger: "blur" },
                ],
                position_id: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
                branch_id: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
            },
            form_positionList = ref([]),
            form_branchList = ref([]),
            form_roleList = ref([]),
            _addstaff = (): void => {
                dialog_show.value = true;
                form_isload.value = true;

                Request.axiosInstance({
                    url: "adminapi/Position/list",
                    data: { status: 1 },
                }).then((res: any) => {
                    form_positionList.value = res?.content?.list || [];
                    Request.axiosInstance({
                        url: "adminapi/Role/list",
                    }).then((res: any) => {
                        form_roleList.value = res?.content?.list || [];
                        form_isload.value = false;
                    });
                });
            },
            screenChange = (e: any, key: any): void => {
                

                getTableData();
            },
            _uprowStatus = (id: number, status: number): void => {
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/Admin/upStateAdminStaff",
                    data: { id: id, status: status == 0 ? 1 : 0 },
                }).then((res: any) => {
                    getTableData();
                });
            },
            handleSizeChange = (size: number): void => {
                screenParameter.pagesize = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                screenParameter.page = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let start_time = screenParameter.time?Math.floor(new Date(screenParameter.time[0]).getTime()/1000):"";
                let end_time = screenParameter.time ?Math.floor((new Date(screenParameter.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data = {...screenParameter,start_time:start_time,end_time:end_time,type:1};
                Request.axiosInstance({
                    url: "adminapi/ConstructionOrder/projectConstructionlist",
                    data,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    selectList.value.total_outputvalue = res?.content?.total_outputvalue;
                    selectList.value.total_yj = res?.content?.total_yj;
                    selectList.value.total_commission = res?.content?.total_commission;
                    
                });
            },
            selectChange = (e: number): void => {
                // console.log(e);
                getTableData();
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                let start_time = screenParameter.time?Math.floor(new Date(screenParameter.time[0]).getTime()/1000):"";
                let end_time = screenParameter.time ?Math.floor((new Date(screenParameter.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                projectConstructionExport({...screenParameter,start_time:start_time,end_time:end_time,type:1}).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            getSummaries = (param:any) => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "output_value",
                    "build_yj",
                    "build_bonus_price"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "output_value") {
                            sums[index] = selectList.value.total_outputvalue;
                        } else if (column.property == "build_yj") {
                            sums[index] = selectList.value.total_yj;
                        } else if (column.property == "build_bonus_price") {
                            sums[index] = selectList.value.total_commission;
                        }
                        if(column.property == "number"){
                            sums[index] = `${sums[index]}`;
                        }else{
                            sums[index] = `¥${sums[index]}`;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            };

        onMounted(() => {
            Promise.all([
                Request.axiosInstance({
                    url: "adminapi/Project/totalList",
                    data: { status: 1 },
                }),
                Request.axiosInstance({
                    url: "adminapi/OrderCar/constructors",
                }),
            ]).then((res: any) => {
                selectList.value.project = res[0]?.content?.list || [];
                selectList.value.staff = res[1]?.content?.staff || [];
                selectList.value.branch = res[1]?.content?.branch || [];
                getTableData();
            });
        });

        return {
            columnList,
            tableData,
            loading,
            total,
			handleSizeChange,
			handleCurrentChange,
            headClass,
            screen,
            screenParameter,
            selectChange,
            dialog_show,
            form,
            formRef,
            formRules,
            form_isload,
            form_positionList,
            form_branchList,
            form_roleList,
            _addstaff,
            _uprowStatus,
            screenChange,
            selectList,
            getSummaries,
            exportChange
        };
    },
});
